import {useMemo, useState} from 'react'
import {
  Currency,
  CurrencyDetails,
  createCurrency,
  getAllCurrencyOptions,
  updateCurrency,
} from './api'
import {useLayout} from '../../../../_metronic/layout/core'
import {KTIcon, OptionType} from '../../../../_metronic/helpers'
import toast from 'react-hot-toast'
import Select from 'react-select'
import {removeIndicatorSeparator, solidSelectStyles} from '../../shared/ui/selectStyles'

export const CreateEditCurrency: React.FC<{
  setCreateCurrency: React.Dispatch<React.SetStateAction<boolean>>
  editCurrency?: Currency
}> = ({setCreateCurrency, editCurrency}) => {
  const {company} = useLayout()
  const [loading, setLoading] = useState(false)
  const [currency, setCurrency] = useState(
    editCurrency?.currencyCode
      ? {
          label: editCurrency.currencyCode,
          value: editCurrency.currencyCode,
        }
      : {
          value: '',
          label: 'Select a Currency...',
        }
  )
  const [decimal, setDecimal] = useState(4)
  const [currencyDetails, setCurrencyDetails] = useState<CurrencyDetails[]>([])
  const [currencyOptions, setCurrencyOptions] = useState<OptionType[]>([])

  const handleCreateNewGroup = async () => {
    setLoading(true)
    createCurrency({
      company_id: Number(company?.value),
      currency_code: currency.value,
      formal_name: currencyDetails.find((c) => c.code === currency.value)?.currency || '',
      currency_symbol: currencyDetails.find((c) => c.code === currency.value)?.symbol || '',
      decimal,
    })
      .then((res) => {
        res?.detail && toast.success(res.detail)
        setCurrency({
          value: '',
          label: 'Select a Currency...',
        })
        setDecimal(2)
      })
      .catch((err) => err && toast.error(err))
      .finally(() => setLoading(false))
    // updateCurrency({

    //   company_id: Number(company?.value) ,
    //   currency_code: currency,
    //   formal_name: currencyOptions.find((c) => c.code === currency)?.currency || '',
    //   currency_symbol: currencyOptions.find((c) => c.code === currency)?.symbol || '',
    //   decimal,
    // })
    //   .then((res) => {
    //     res?.detail && toast.success(res.detail)
    //     setCurrency('')
    //     setDecimal(2)
    //   })
    //   .catch((err) => err && toast.error(err))
    //   .finally(() => setLoading(false))
  }

  useMemo(async () => {
    const res = await getAllCurrencyOptions()
    res && setCurrencyDetails(res)
    res &&
      setCurrencyOptions(
        res.map((v: any) => ({
          label: v.code,
          value: v.code,
        }))
      )
  }, [])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <div
            data-bs-toggle='tooltip'
            data-bs-trigger='hover'
            data-bs-dismiss-='click'
            title='Go Back'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
            style={{marginRight: '5px'}}
            onClick={() => setCreateCurrency(false)}
          >
            <KTIcon iconName='arrow-left' className='fs-2' />
          </div>
          <h3 className='fw-bolder m-0'>
            {!!editCurrency ? 'Update Currency' : 'Add New Currency'}
          </h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Select Currency</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <Select
                // {...formik.getFieldProps('reportingCurrency')}
                value={currency}
                onChange={(option: any) => setCurrency(option as OptionType)}
                options={currencyOptions}
                isSearchable={true}
                className={'fw-bold'}
                styles={solidSelectStyles}
                components={removeIndicatorSeparator}
              />
              {/* <select
                className='form-select form-select-solid form-select-lg fw-bold'
                value={currency}
                onChange={(e) => setCurrency(e.currentTarget.value)}
              >
                <option value=''>Select a Currency...</option>
                {currencyOptions.map((c) => (
                  <option value={c.code}>{c.code}</option>
                ))}
              </select> */}
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Formal Name</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <select
                className='form-select form-select-disabled form-select-lg fw-bold'
                value={currency.value}
                disabled={true}
              >
                <option value={currency.value}>
                  {currencyDetails.find((c) => c.code === currency.value)?.currency || ''}
                </option>
              </select>
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Currency Symbol</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <select
                className='form-select form-select-disabled form-select-lg fw-bold'
                value={currency.value}
                disabled={true}
              >
                <option value={currency.value}>
                  {currencyDetails.find((c) => c.code === currency.value)?.symbol}
                </option>
              </select>
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
              Decimal Precision
            </label>

            <div className='col-lg-8 fv-row'>
              <input
                type='number'
                className='form-control form-control-lg form-control-solid'
                placeholder='Group name'
                value={decimal}
                onChange={(e) => setDecimal(Number(e.target.value))}
              />
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            className='btn btn-secondary'
            style={{marginRight: '10px'}}
            onClick={() => setCreateCurrency(false)}
          >
            Cancel
          </button>
          <button
            onClick={handleCreateNewGroup}
            className='btn btn-primary ml-2'
            disabled={loading}
          >
            {!loading && !!editCurrency ? 'Save Currency' : 'Add Currency'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
